/* Sorting for the fleet table, kept free of React so it can be unit-tested. */

const str = (v) => String(v || '').toLowerCase();
const attentionTotal = (d) =>
  (d.pages_draft || 0) + (d.pages_missing_description || 0) + (d.pages_image_error || 0);

/* What each column sorts on.  Derived metrics come from the accessors the
   container passes in, so sorting and the footer totals always agree.  A
   null means the cell renders "—", so these mirror the cell rules below. */
const shown = (v) => (v > 0 ? v : null);           // cells that show "—" for 0
const known = (v) => (v == null ? null : Number(v)); // cells that show "—" only when unset

const sortValue = (column, d, m, e) => {
  switch (column) {
    case 'is_favorite': return d.is_favorite ? 1 : 0;
    case 'page_hits': return shown(m.hits(d));
    // null (unknown) until the refresh job has labelled views; 0 is a real 0
    case 'human_hits': return known(m.humanHits ? m.humanHits(d) : null);
    case 'adsense': return shown(e.adsense(d));
    case 'amazon': return shown(e.amazon(d));
    case 'total_earnings': return shown(e.total(d));
    case 'ad_impressions': return shown(m.impressions(d));
    case 'ads_per_hit': return known(m.adsPerHit(d));
    case 'ecpm': return known(m.ecpm(d));
    case 'rpm': return known(m.rpm(d));
    case 'read_rate': return known(m.readRate && m.readRate(d));
    case 'read_time': return known(m.readTime && m.readTime(d));
    case 'amz_impr': return shown(m.amzImpr(d));
    // a site with offers seen shows its clicks even at 0; "—" only with none
    case 'amz_clicks': return (m.amzImpr(d) > 0 || m.amzClicks(d) > 0) ? m.amzClicks(d) : null;
    case 'page_count': return known(d.page_count);
    case 'pages_created_this_month': return known(d.pages_created_this_month);
    case 'pages_scheduled': return known(d.pages_scheduled);
    case 'attention': return attentionTotal(d);
    default: return null;
  }
};

const TEXT_COLUMNS = ['hostname', 'dns_target', 'hosting_service'];

/* Blank ("—") rows always sink to the bottom, whichever way the column is
   sorted; the direction only orders the rows that have a value.  Ties, and
   the blank rows themselves, fall back to hostname A–Z. */
export const sortDomains = (domains, column, direction, m, e) => {
  const dir = direction === 'asc' ? 1 : -1;
  const byHost = (a, b) => str(a.hostname).localeCompare(str(b.hostname));
  if (TEXT_COLUMNS.includes(column)) {
    return [...domains].sort((a, b) => {
      const av = str(a[column]);
      const bv = str(b[column]);
      if (!av !== !bv) return av ? -1 : 1;
      return dir * av.localeCompare(bv) || byHost(a, b);
    });
  }
  return [...domains].sort((a, b) => {
    const av = sortValue(column, a, m, e);
    const bv = sortValue(column, b, m, e);
    if (av == null || bv == null) {
      if (av == null && bv == null) return byHost(a, b);
      return av == null ? 1 : -1;
    }
    return dir * (av - bv) || byHost(a, b);
  });
};
